import { Link } from "react-router-dom";
import { BrandLogo, BrandWordmark } from "@/components/Brand";

export const SUPPORT_EMAIL = "support@workandkeep.app";

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="legal-page">
      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-md border-b border-border">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 h-28 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link">
            <BrandLogo className="h-24 w-auto max-w-[420px] object-contain object-left" />
          </Link>
          <Link to="/login" className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors">
            Sign in
          </Link>
        </div>
      </header>

      <main className="flex-1 mx-auto max-w-3xl w-full px-5 sm:px-8 py-14 lg:py-20">
        <h1 className="font-heading text-4xl sm:text-5xl text-foreground">{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-muted-foreground mt-3">Last updated: {lastUpdated}</p>
        )}
        <div className="legal-content mt-10 space-y-8 text-foreground/85 leading-relaxed">
          {children}
        </div>
      </main>

      <footer className="border-t border-border">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-x-8 gap-y-4">
          <BrandWordmark className="text-xl text-foreground whitespace-nowrap shrink-0" />
          <p className="text-xs text-muted-foreground text-center">
            Work &amp; Keep is operated by Wholehearted Wellness LLC. &copy; {new Date().getFullYear()} Wholehearted Wellness LLC. All rights reserved.
          </p>
          <nav className="flex items-center gap-6 text-sm shrink-0">
            <Link to="/privacy" className="text-foreground/70 hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="text-foreground/70 hover:text-foreground transition-colors">Terms</Link>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-foreground/70 hover:text-foreground transition-colors">Contact</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section className="space-y-3">
      <h2 className="font-heading text-2xl text-foreground">{heading}</h2>
      {children}
    </section>
  );
}
